export const FEATURES = {
    "SERVICE_FEES" : true,
    "INVOICES" : true,
    "BORIKA" : false,
    "MSTS": false,
    "EURO_SWITCH_PERIOD": true,
}